import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-callback-container" }
const _hoisted_2 = { class: "auth-callback-container__message" }

import { defineAsyncComponent, shallowRef } from 'vue';
import { useRouter } from 'vue-router';

import { modalService } from '@exchange/libs/modals/src';
import { getNextPathUponLogin } from '@exchange/routing';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthCallback',
  setup(__props) {

const ErrorModal = defineAsyncComponent(() => import('@exchange/libs/modals/src/lib/common/ErrorModal.vue'));

const router = useRouter();

const showErrorModal = (error) => {
  if (!error) {
    return;
  }

  modalService.show(
    shallowRef(ErrorModal),
    {
      messageKey: 'modules.errors.loginFailed',
    },
    {
      'x-error-close': () => {
        modalService.clear();
      },
    },
  );
};

const processLogin = async () => {
  try {
    const next = await getNextPathUponLogin();

    return await router.replace(next);
  } catch (e) {
    return router.replace('/').then(() => showErrorModal(e));
  }
};

processLogin();

return (_ctx: any,_cache: any) => {
  const _component_ot_spinner = _resolveComponent("ot-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modules.login.loggingYouInMessage')), 1),
    _createVNode(_component_ot_spinner, { class: "auth-callback-container__spinner" })
  ]))
}
}

})